// Module
var code = "<ng-form> <kform-builder-option property=\"validate.card\"></kform-builder-option> <kform-builder-option property=\"validate.customMessage\"></kform-builder-option> <kform-builder-option-custom-validation></kform-builder-option-custom-validation> </ng-form>";
// Exports
export default code;